import { render, staticRenderFns } from "./legend-years.vue?vue&type=template&id=c1909a52&scoped=true"
import script from "./legend-years.vue?vue&type=script&lang=js"
export * from "./legend-years.vue?vue&type=script&lang=js"
import style0 from "./legend-years.vue?vue&type=style&index=0&id=c1909a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1909a52",
  null
  
)

export default component.exports